import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {GenCategory} from '../models/genCategory.model';

@Injectable({
    providedIn: 'root',
})
export class CategoriesService {
    private cachedCategories: { [key: string]: GenCategory[] } = {}; // Cache object with keys based on query params

    constructor(private apiService: ApiService) {
    }

    // Get list of categories with caching
    async getCategories(params?: any): Promise<{ data: GenCategory[]; headers: any }> {
        const cacheKey = this.generateCacheKey(params);

        // Check if data is already cached
        if (this.cachedCategories[cacheKey]) {
            return {data: this.cachedCategories[cacheKey], headers: null}; // Return cached data
        }

        const queryParams: any = {};

        if (params) {
            if (params.sort) {
                queryParams.sort = params.sort;
            }
            if (params.pageSize) {
                queryParams.pageSize = params.pageSize;
            }
            if (params.page) {
                queryParams.page = params.page;
            }
            if (params.filter && Object.keys(params.filter).length > 0) {
                queryParams.filter = params.filter;
            }
        }

        const response = await this.apiService.get<GenCategory[]>('/categories', queryParams);
        const data = response.body || [];
        const headers = response.headers;

        // Cache the fetched data
        this.cachedCategories[cacheKey] = data;

        return {data, headers};
    }

    // Get category by UUID
    async getCategoryByUuid(uuid: string, queryParams: any): Promise<GenCategory> {
        const response = await this.apiService.get<GenCategory>(`/categories/${uuid}`, queryParams);
        return response.body!;
    }

    // Clear cache (optional method to manually invalidate cache)
    clearCache(): void {
        this.cachedCategories = {};
    }

    // Generate a unique cache key based on query params
    private generateCacheKey(params?: any): string {
        return JSON.stringify(params || {});
    }

    // Additional category-related methods can be added here
}
